module.exports = __webpack_public_path__ + "static/media/ic_sync.eb027008.svg";